import React, { useState, useMemo, useEffect } from "react";
import { connect } from "react-redux";
import { Row, Col, Card, CardDeck, Form } from "react-bootstrap";
import SVGGeoShape from "../../geo-region/SVGGeoShape";
import { SearchInput } from "../../widgets";
import { Button } from "react-bootstrap";

const FieldSelection = (props) => {
    const { settings, fieldListById, isRequestingGeoRegion, state, handleState } = props;
    let filteredFieldListById = {};

    Object.keys(fieldListById).forEach(item => {
        if (fieldListById[item].regionDetails && fieldListById[item].regionDetails.geo_region_type_id === 2) {
            filteredFieldListById = { ...filteredFieldListById, [item]: fieldListById[item] };
        }
    });

    const { selectedFields, isAllShapes, isNoWorkPlan } = state;

    const [searchText, setSearchText] = useState("");
    const [availableSearchText, setAvailableSearchText] = useState("");

    useEffect(() => {
        if (!state.workPlanMethodId === 2 && selectedFields.length > 0) updateState(selectedFields);
    }, [state.workPlanMethodId]);

    // get remaining field list
    const remainingFields = Object.keys(filteredFieldListById).filter(id =>
        !selectedFields.find(field => filteredFieldListById[id].geo_shape_uuid === field.geo_shape_uuid))
        .map(id => ({
            geo_shape_uuid: filteredFieldListById[id].geo_shape_uuid,
            geo_region_uuid: filteredFieldListById[id].regionDetails.geo_region_uuid
        }));

    const updateState = (selectedFields) => {
        const updatedPlannedAcres = getTotalAcres(selectedFields);
        handleState({ ...state, selectedFields, plannedAcres: updatedPlannedAcres });
    }

    const handleRemoveButton = (item) => {
        const list = selectedFields.filter(field => field.geo_shape_uuid !== item.geo_shape_uuid);
        updateState(list);
    }

    const handleAddButton = (item) => {
        const list = [...selectedFields, {
            geo_shape_uuid: item.geo_shape_uuid,
            geo_region_uuid: item.geo_region_uuid
        }];
        updateState(list);
    }

    const filterData = (fields, searchQuery) => fields.filter(selectedField => {
        const field = filteredFieldListById[selectedField.geo_shape_uuid];
        return field && field.geo_shape_name.toLowerCase().indexOf(searchQuery.toLowerCase()) !== -1;

    })

    const getTotalAcres = (selectedFields) => {
        const acres = selectedFields.reduce((acres, selectedField) => {
            const field = filteredFieldListById[selectedField.geo_shape_uuid];
            return field ? acres + (Number(field.regionDetails.totalAcres) || 0) : acres + 0
        }, 0);
        return acres === 0 ? acres : acres.toFixed(2);
    }

    const filteredSelectedFields = useMemo(() => filterData(selectedFields, searchText), [selectedFields, searchText, filteredFieldListById]);
    const filteredRemainingFields = useMemo(() => filterData(remainingFields, availableSearchText), [remainingFields, availableSearchText]);
    const remainingAcres = useMemo(() => getTotalAcres(remainingFields), [remainingFields]);
    const isDisabled = state.isNoWorkPlan || state.workPlanMethodId !== 2;

    const handleToggleChange = (checked) => {
        handleState({ ...state, isAllShapes: checked });
    };
    return <Row className="geo-selection">
        <Col className="selected-list">
            <Row className="selected-list-header">
                <Col lg="6" className="p-0"><label className="field-label">Selected Fields</label> : {selectedFields.length}</Col>
                <Col lg={6}>
                    <Form.Check
                        type="switch"
                        id="all-region-toggle"
                        label="Show All Regions On Map"
                        checked={isAllShapes}
                        className={`d-flex justify-content-end ${isNoWorkPlan ? "disabled" : ""}`}
                        disabled={isNoWorkPlan}
                        onChange={e => handleToggleChange(e.target.checked)}
                    />
                </Col>
            </Row>
            <Row className="m-0">
                <Col className="search-input mb-2" lg="6">
                    <SearchInput onChange={searchText => setSearchText(searchText)} />
                </Col>
            </Row>
            <CardDeck className={`m-0 geo-items ${((!isRequestingGeoRegion && filteredSelectedFields.length === 0) || isRequestingGeoRegion) ? 'page-loading' : ''}`}>
                {filteredSelectedFields.map(item => <Card key={item.geo_shape_uuid} className={`geo-item ${isDisabled ? 'disabled' : ''}`}>
                    <Row className="m-0">
                        <p className="name"><span title={filteredFieldListById[item.geo_shape_uuid].geo_shape_name}>{filteredFieldListById[item.geo_shape_uuid].geo_shape_name}</span></p>
                        <span className={`remove-btn close ${isDisabled ? 'disabled' : ''}`}>
                            <span title="Remove" onClick={() => handleRemoveButton(item)}>×</span>
                        </span>
                    </Row>
                    <Row className="region-plot m-0">
                        <SVGGeoShape
                            location={filteredFieldListById[item.geo_shape_uuid].location}
                            color={filteredFieldListById[item.geo_shape_uuid].properties.fillColor}
                            width="122px" height="122px" />
                    </Row>
                    <Row className="acres m-0">
                        {`${settings.areaShortName} : ${filteredFieldListById[item.geo_shape_uuid].regionDetails.totalAcres}`}
                    </Row>
                </Card>
                )}
                {isRequestingGeoRegion && <div>Loading...</div>}
                {!isRequestingGeoRegion && filteredSelectedFields.length === 0 && <div>{selectedFields.length === 0 ? 'None selected' : 'No data found'}</div>}
            </CardDeck>
        </Col>
        <Col lg={3} sm={3} md={3} className="available-list h-100">
            <div className="available-list-header">
                <div><label className="field-label">Remaining Fields:</label>{remainingFields.length}</div>
                <div><label className="field-label">Remaining {settings.areaShortName}:</label>{remainingAcres}</div>
            </div>
            <div className="search-input">
                <SearchInput className="w-100" onChange={searchText => setAvailableSearchText(searchText)} />
            </div>
            <div className={`m-0 geo-items ${((!isRequestingGeoRegion && filteredRemainingFields.length === 0) || isRequestingGeoRegion) ? 'page-loading' : ''}`}>
                {filteredRemainingFields.map(item => <Card key={item.geo_shape_uuid} className={`w-100 geo-item ${isDisabled ? 'disabled' : ''}`}>
                    <div>
                        <Row className="name m-0"> {filteredFieldListById[item.geo_shape_uuid].geo_shape_name}</Row>
                        <Row className="sub-name m-0">{`${settings.areaShortName} : ${filteredFieldListById[item.geo_shape_uuid].regionDetails.totalAcres}`}</Row>
                    </div>
                    <Button disabled={isDisabled} className="btn-success btn-sm" title={"Add Field"} onClick={() => handleAddButton(item)}>Add</Button>
                </Card>)}
                {isRequestingGeoRegion && <div>Loading...</div>}
                {!isRequestingGeoRegion && filteredRemainingFields.length === 0 && <div>No data found</div>}
            </div>
        </Col>
    </Row>
}

const mapStateToProps = (state) => ({
    fieldListById: state.crewKanban.fieldListById,
    isRequestingGeoRegion: state.crewKanban.isRequestingGeoRegion,
    settings: state.user.settings
})

export default connect(mapStateToProps)(FieldSelection);